<template>
  <div>
    <v-layout class="ml-4 mt-4 mr-2">
      <div :class="ui.textHeadline">
        {{this.companyTitle2}} password reset
      </div>
      <v-spacer/>
      <div :class="ui.responseShowXs">
        <v-btn flat icon small :color="ui.btnColor" :to="'/'">
          <v-icon dark>home</v-icon>
        </v-btn>
      </div>
      <div :class="ui.responseHideXs">
        <v-btn outline small :color="ui.btnColor" :to="'/'">
          <v-icon dark left>home</v-icon>
          home
        </v-btn>
      </div>
    </v-layout>
    <v-container>
    <v-layout>
      <v-flex xs12 sm6 lg4 offset-sm3 offset-lg4>
        <v-card>
          <v-img class="white--text" height="280px"
          :src="require('@/app/assets/images/nature02.jpg')">
            <v-container fill-height fluid>
              <v-layout fill-height>
               <v-flex xs12 align-end flexbox>
                 <span :class="ui.textHeadlineLight">change password</span>
               </v-flex>
              </v-layout>
            </v-container>
          </v-img>
          <v-card-text>
            <v-layout row class="ml-4 mr-4 mt-4">
              <div :class="ui.textSubheading">
                Please review your email inbox or junk mail and follow password change link from Besea Team.
              </div>
            </v-layout>
            <v-layout row class="mt-4">
              <v-spacer/>
              <v-btn
                :to="'/signin'"
                :color="ui.btnColor"
                flat
              >
                <v-icon left> person </v-icon>
                sign in
              </v-btn>
            </v-layout>
            <v-layout row class="mt-4">
              <PublicFooterCard :data="{bkgd: 'white'}"/>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    </v-container>
    <InfoSnackbar/>
  </div>

</template>

<script>
import InfoSnackbar from "@/frame/messages/components/InfoSnackbar";
import createUser from "@/user/auth/mixins/createUser.js";
import formSignup from "@/data/rules/mixins/formSignup.js";
import apptheme from "@/frame/theme/mixins/apptheme.js";
import PublicFooterCard from "@/public/components/PublicFooterCard";
import publicGlobals from "@/data/globals/mixins/publicGlobals.js";

export default {
  components: {
    InfoSnackbar,
    PublicFooterCard
  },
  mixins: [createUser, formSignup, apptheme, publicGlobals],
  data: () => ({
    valid: true,
    enableBtnSpinSignup: false,
    btnInfo1: {
      color: "red",
      icon: "person",
      name: "add user"
    }
  })
};
</script>
